import { RouteConfig } from 'vue-router'

const route: RouteConfig[] = [
  {
    path: '/myfiles',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('components/ELibrary/ELibrary.vue')
      }
    ],
    meta: { requiresAuth: true }
  }
]

export default route
